<template>
  <v-row class=" mt-15 mx-auto">
    <v-col
      cols="12"
      sm="12"
      md="12"
      class="pa-0"
    >
      <div class="d-flex">
        <v-layout row>
          <v-flex
            class="box"
            xs12
            sm6
            md5
          >
            <v-container
              class="white pa-0"
            >
              <v-layout
                flex
                justify-center
                align-center
              >
                <v-row>
                  <v-col>
                    <v-card
                      flat
                      class="ml-6 pa-4"
                    >
                      <div class="text-uppercase font-weight-black pt-8 text-h5 mb-4">
                          FINVOTE
                        </div>
                      <v-card-text class="pa-0 pt-6">
                        <v-form>
                          <v-text-field
                            outlined
                            label="Username"
                          />
                          <v-text-field
                          type="password"
                            outlined
                            label="Password"
                          />
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <a href="" style="text-decoration: none" class="deep-purple--text">

                          Forgot password?
                        </a>
                        <v-spacer />
                        <v-btn fab small color="deep-purple" @click="handleLogin">
                          <v-icon  color="white">mdi-arrow-right</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-layout>
            </v-container>
          </v-flex>
          <v-flex
          align-self-center
            class="box hidden-xs-only"
            xs12
            sm6
            md7
          >
            <v-img
            class="mx-auto"
            width="70%"
              height="100%"
              src="@/assets/login_screen.jpg"
            />
          </v-flex>
        </v-layout>
      </div>
    </v-col>
    </v-row>
    
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    handleLogin() {
      this.$router.push({name: 'Dashboard'})
    }
  }
};
</script>
